// Tenantra Inc. - 12-month payment timeline that fills on scroll (one late month shown)
import { useEffect, useState } from 'react';
import { useScrollAnimation } from './useScrollAnimation';

const MONTHS = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
const LATE_INDEX = 7;

export const PaymentTimeline = () => {
  const [ref, visible] = useScrollAnimation(0.4);
  const [filled, setFilled] = useState(0);

  useEffect(() => {
    if (!visible) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setFilled(12); return; }
    const timers = MONTHS.map((_, i) => setTimeout(() => setFilled(i + 1), 200 + i * 130));
    return () => timers.forEach(clearTimeout);
  }, [visible]);

  return (
    <div ref={ref} className="bg-white border border-stone-200 rounded-lg p-5 sm:p-6" data-testid="payment-timeline">
      <div className="flex items-start justify-between mb-5">
        <div>
          <p className="text-xs text-stone-500 mb-1">12-month history</p>
          <p className="text-sm font-semibold text-stone-900">R. Gagnon, 41 Birchmount Rd, Upper</p>
        </div>
        <p className="text-sm tabular-nums text-stone-900">$1,850.00<span className="text-stone-400">/mo</span></p>
      </div>

      <div className="grid grid-cols-12 gap-1.5 mb-2">
        {MONTHS.map((m, i) => {
          const on = i < filled;
          const late = i === LATE_INDEX;
          return (
            <div key={m} className="flex flex-col items-center gap-1.5">
              <div
                className={`w-full h-10 rounded-sm border transition-colors duration-300 ${!on ? 'bg-stone-50 border-stone-200' : late ? 'bg-amber-100 border-amber-300' : 'bg-teal-600 border-teal-700'}`}
                data-testid={`timeline-month-${i}`}
              />
              <span className="text-[10px] sm:text-xs text-stone-500">{m}</span>
            </div>
          );
        })}
      </div>

      <div className="mt-5 pt-4 border-t border-stone-200 grid grid-cols-3 gap-3 text-xs">
        <div>
          <p className="text-xs text-stone-500">On time</p>
          <p className="text-stone-900 font-semibold mt-0.5">11 of 12</p>
        </div>
        <div>
          <p className="text-xs text-stone-500">Late</p>
          <p className="text-amber-800 font-semibold mt-0.5">Feb, paid 14 days late</p>
        </div>
        <div>
          <p className="text-xs text-stone-500">Reported</p>
          <p className="text-stone-900 font-semibold mt-0.5">Every month, as it happened</p>
        </div>
      </div>
    </div>
  );
};
